import MyAccountMessage from './MyAccountMessage'

export default MyAccountMessage
// eslint-disable-next-line import/export
export * from './MyAccountMessage'
